import { render, staticRenderFns } from "./lateral-panel.vue?vue&type=template&id=c60b79da&scoped=true"
import script from "./lateral-panel.vue?vue&type=script&lang=js"
export * from "./lateral-panel.vue?vue&type=script&lang=js"
import style0 from "./lateral-panel.vue?vue&type=style&index=0&id=c60b79da&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c60b79da",
  null
  
)

export default component.exports